var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBook = function SvgBook(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "book_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#book_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.447 26.875a3.68 3.68 0 0 1-2.703-1.12 3.68 3.68 0 0 1-1.119-2.702V7.188q0-1.693 1.185-2.878t2.878-1.185h12.427q.933 0 1.596.664.664.663.664 1.596V20.56a.57.57 0 0 1-.173.403q-.174.18-.56.347a1.812 1.812 0 0 0-1.214 1.743q0 .6.328 1.078.328.477.874.665.352.14.55.39.195.253.195.54v.192a.94.94 0 0 1-.27.677.9.9 0 0 1-.668.28zm1.731-7.644q.4 0 .668-.27.27-.27.27-.668V5.938a.9.9 0 0 0-.27-.669.9.9 0 0 0-.668-.269.9.9 0 0 0-.668.27.9.9 0 0 0-.27.668v12.355q0 .4.27.668.27.27.668.27M9.448 25h11.68a3.8 3.8 0 0 1-.424-.905 3.4 3.4 0 0 1-.151-1.042q0-.536.142-1.029.14-.494.433-.918H9.448q-.837 0-1.393.568a1.9 1.9 0 0 0-.555 1.379q0 .835.555 1.392Q8.61 25 9.447 25"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBook);
export default ForwardRef;